import React from "react"
import _ from "underscore"
import { Plus, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import Input from "../input"

class EditTimes extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      times: this.props.times.length > 0 ? this.props.times : [{ start_time: "00:00", end_time: "00:00" }]
    }
  }

  onEditStartTime = (start_time, index) => {
    const updatedTimes = this.state.times.map((time, currentIndex) => {
      if (currentIndex === index) {
        return { ...time, start_time }
      }
      return time
    })

    this.setState({ times: updatedTimes })
  }

  onEditEndTime = (end_time, index) => {
    const updatedTimes = this.state.times.map((time, currentIndex) => {
      if (currentIndex === index) {
        return { ...time, end_time }
      }

      return time
    })

    this.setState({ times: updatedTimes })
  }

  onRemoveTime = (index) => {
    this.setState({ times: this.state.times.filter((_, idx) => idx !== index) })
  }

  onEditTimes = () => {
    const times = this.state.times
    this.props.onEditTimes({times: times})
  }

  onAddTime = () => {
    const new_time = { start_time: "00:00", end_time: "00:00" }
    this.setState({ times: [...this.state.times, new_time] })
  }

  onCancelEdit = () => {
    this.props.onCancelEdit()
  }

  render(){
    let times = this.state.times
    const day_of_week = this.props.day_of_week.charAt(0).toUpperCase() + this.props.day_of_week.slice(1)

    return (
      <div className="grid gap-4 rounded-[10px] border border-border bg-card p-4">
        <div className="text-sm font-semibold">
          Edit {day_of_week}'s Times
        </div>
        {times.length > 0 ?
          <div className="grid gap-2">
            {_.map(times, (time, index) => {
              return (
                <div key={`${time}-${index}`} className="flex items-center gap-2">
                  <Input type="time" value={time.start_time} className="cursor-pointer" onChange={(start_time) => this.onEditStartTime(start_time, index)}/>
                  <span> - </span>
                  <Input type="time" value={time.end_time} className="cursor-pointer" onChange={(end_time) => this.onEditEndTime(end_time, index)}/>
                  <Button variant="outline" size="sm" className="ml-2" onClick={() => this.onRemoveTime(index)}>
                    <Trash2 className="size-3.5"/>
                  </Button>
                </div>
              )
            })}
          </div>
        :
          <span className="text-sm text-muted-foreground">No Availability Specified</span>
        }
        <Button variant="link" size="sm" className="justify-self-start px-0" onClick={this.onAddTime}>
          <Plus className="size-3.5"/> Add another time
        </Button>
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={this.onCancelEdit}>
            Cancel
          </Button>
          <Button size="sm" onClick={this.onEditTimes}>
            Save
          </Button>
        </div>
      </div>
    )
  }
}

export default EditTimes
